<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Balance Details</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="balanceCheckForm">
            <div class="row d-flex justify-content-center">

                <div class="col-md-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Customer Reference Number</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter Customer Reference Number" id="customerAccNo" matInput
                                formControlName="customerAccNo" type="text" #searchInput required>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="generateCustBalance()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>

                </div>
                <div class="col-xl-1 mb-3" style="height: fit-content;align-self: end;">

                    <button class="btn reset_btn " (click)="searchreset()">
                        Reset
                    </button>
                </div>
            </div>
        </form>
        <!-- <div class="row justify-content-center mt-3" *ngIf="IsHaveTable">
            <div class="col-xl-2 my-3">
                <div class="cards p-0">
                    <p class="heading_text m-0">90 Days</p>
                    <p class="para m-0">R {{customerBalance?.d90plus ? customerBalance.d90plus : '0.00'}}</p>
                </div>
            </div>
            <div class="col-xl-2 my-3">
                <div class="cards p-0">
                    <p class="heading_text m-0">60 Days</p>
                    <p class="para m-0">R {{customerBalance?.d60plus ? customerBalance.d60plus : '0.00'}}</p>
                </div>
            </div>
            <div class="col-xl-2 my-3">
                <div class="cards p-0">
                    <p class="heading_text m-0">30 Days</p>
                    <p class="para m-0">R {{customerBalance?.d30plus ? customerBalance.d30plus : '0.00'}}</p>
                </div>
            </div>
            <div class="col-xl-2 my-3">
                <div class="cards p-0">
                    <p class="heading_text m-0">Current</p>
                    <p class="para m-0">R {{customerBalance?.dcurrent ? customerBalance.dcurrent : '0.00'}}</p>
                </div>
            </div>
            <div class="col-xl-2 my-3">
                <div class="cards p-0">
                    <p class="heading_text m-0">Total Outstanding</p>
                    <p class="para m-0">R {{customerBalance?.totalAmount ? customerBalance.totalAmount : '0.00'}}</p>
                </div>
            </div>
        </div> -->

        <div class="row d-flex justify-content-center cards-row" style="flex-wrap:wrap;" *ngIf="IsHaveTable">

            <div class="col-2 mt-3 ">
                <div class="card px-2 py-3 card1">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">

                            <div style="font-size: 25px; font-weight: 600; color:#9700d1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">R {{customerBalance?.d90plus ? customerBalance.d90plus : '0.00'}}</div>
                        </div>
                        <div class="col-12 d-flex justify-content-center" style="font-size: 14px;">
                               90 Days
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 mt-3 ">
                <div class="card px-2 py-3 card1">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">

                            <div style="font-size: 25px; font-weight: 600;color:#9700d1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">R {{customerBalance?.d60plus ? customerBalance.d60plus : '0.00'}}</div>
                        </div>
                        <div class="col-12 d-flex justify-content-center" style="font-size: 14px;">
                               60 Days
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 mt-3 ">
                <div class="card px-2 py-3 card1">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">

                            <div style="font-size: 25px; font-weight: 600;color:#9700d1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">R {{customerBalance?.d30plus ? customerBalance.d30plus : '0.00'}}</div>
                        </div>
                        <div class="col-12 d-flex justify-content-center" style="font-size: 14px;">
                               30 Days
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 mt-3 ">
                <div class="card px-2 py-3 card1">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">

                            <div style="font-size: 25px; font-weight: 600;color:#9700d1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">R {{customerBalance?.dcurrent ? customerBalance.dcurrent : '0.00'}}</div>
                        </div>
                        <div class="col-12 d-flex justify-content-center" style="font-size: 14px;">
                           Current
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2 mt-3 ">
                <div class="card px-2 py-3 card1">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-center">

                            <div style="font-size: 25px; font-weight: 600;color:#9700d1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">R {{customerBalance?.totalAmount ? customerBalance.totalAmount : '0.00'}}</div>
                        </div>
                        <div class="col-12 d-flex justify-content-center" style="font-size: 14px;">
                            Total  Outstanding
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>